const shopLocations = ['us', 'gb', 'de', 'at', 'fr', 'es', 'it', 'nl', 'au', 'nz', 'eu', 'ar', 'co', 'pe', 'mx', 'ca', 'kr', 'jp'];

const euCountries = ['be', 'bg', 'cz', 'dk', 'de', 'ee', 'ie', 'gr', 'es', 'fr', 'hr', 'it', 'cy', 'lv', 'lt', 'lu', 'hu', 'mt', 'nl', 'at', 'pl', 'pt', 'ro', 'si', 'sk', 'fi', 'se'];

const latamCountries = ['ar', 'co', 'pe', 'mx', 'cl', 'hn', 'do', 'cr', 'gt', 'pa'];

var latam = false;

const shopMap = {
  // country : shopregion
  "us": "us",
  "gb": "uk",
  "uk": "uk",
  "fr": "fr",
  "de": "de",
  "at": "de",
  "es": "es",
  "it": "it",
  "nl": "nl",
  "au": "au",
  "nz": "nz",
  "ca": "ca",
	// EU
  "eu": "eu",
  "ie": "eu",
  "be": "eu",
  "bg": "eu",
  "cz": "eu",
  "dk": "eu",
  "ee": "eu",
  "ie": "eu",
  "gr": "eu",
  "hr": "eu",
  "cy": "eu",
  "lv": "eu",
  "lt": "eu",
  "lu": "eu",
  "hu": "eu",
  "mt": "eu",
  "pl": "eu",
  "pt": "eu",
  "ro": "eu",
  "si": "eu",
  "sk": "eu",
  "fi": "eu",
  "se": "eu",
  "no": "eu",
  //LATAM
  "ar": "mx",
  "co": "mx",
  "pe": "mx",
  "mx": "mx",
  "cl": "mx",
  "hn": "mx",
  "do": "mx",
  "cr": "mx",
  "gt": "mx",
  "pa": "mx",
  // APAC
  "kr": "kr",
  "jp": "jp",
}


  if (typeof window.geoUrlMap !== undefined) {
    var siteLinks = {
      "us": geoUrlMap.us,
      "eu": geoUrlMap.eu,
      "uk": geoUrlMap.uk,
      "gb": geoUrlMap.uk,
      "de": geoUrlMap.de,
      "fr": geoUrlMap.fr,
      "nl": geoUrlMap.nl,
      "es": geoUrlMap.es,
      "it": geoUrlMap.it,
      "au": geoUrlMap.au,
      "nz": geoUrlMap.nz,
      "mx": geoUrlMap.latam,
      "ca": geoUrlMap.ca,
      "kr": geoUrlMap.kr,
      "jp": geoUrlMap.jp
    }
  } else {
    var siteLinks = {
      "us": "https://www.turtlebeach.com",
      "eu": "https://eu.turtlebeach.com",
      "uk": "https://uk.turtlebeach.com",
      "gb": "https://uk.turtlebeach.com",
      "de": "https://de.turtlebeach.com",
      "fr": "https://fr.turtlebeach.com",
      "nl": "https://nl.turtlebeach.com",
      "es": "https://es.turtlebeach.com",
      "it": "https://it.turtlebeach.com",
      "au": "https://au.turtlebeach.com",
      "nz": "https://nz.turtlebeach.com",
      "mx": "https://latam.turtlebeach.com",
      "ca": "https://ca.turtlebeach.com",
      "kr": "https://kr.turtlebeach.com",
      "jp": "https://jp.turtlebeach.com"
    }
  }


theme.geoip = {
  init: function() {
    //bind to click event of country selector
    var countrySelectors = [].slice.call(document.querySelectorAll('.other-sites .site-nav__submenu .site-nav__link'));
    countrySelectors.forEach(function(countrySelector) {
      var country = countrySelector.querySelector('span').innerText;
      countrySelector.onclick = function() {
        if (country.toLowerCase() === 'latam') {
          country = 'mx';
        }
        theme.geoip.setCookie(country.toLowerCase());
      }
    });

    //bind to clicks of international site links on the popup
    var siteSelectors = [].slice.call(document.querySelectorAll('.international-site-list li'));
    siteSelectors.forEach(function(siteSelector) {
      var country = siteSelector.id;
      var link = siteSelector.querySelector('a');
      link.onclick = function() {
        theme.geoip.setCookie(country.toLowerCase());
      }
    });

    theme.geoip.checkCountry();
  },
  checkCountry: function() {
    var currentLocale = theme.geoip.getCookie();
    if (currentLocale === 'at') {
      currentLocale = 'de';
    }
    geoip2.country(
      function(location) {
        var countryByIp = location.country.iso_code.toLowerCase();
        var currentSite = theme.geoip.getCurrentSite();

        if (currentLocale) {
          theme.geoip.routeSite(currentSite, currentLocale, countryByIp);
        } else  {
          theme.geoip.routeSite(currentSite, "", countryByIp);
        }
      },
      function(error) {
        //error handling goes here
      }
    );
  },
  cleanJSONFromServer: function(jsonObject) {
    var jsonCleaned = jsonObject.replace(/&quot;/g,'"').replace(/=&gt;/g,':'); //Prepare for JSON parse
    return JSON.parse(jsonCleaned);
  },
  getWelcomeString: function(ipCountry) {
    // Get text data for a welcome
    var welcomeObject = theme.geoip.cleanJSONFromServer("{&quot;us&quot;=&gt;&quot;Welcome to Turtle Beach!&quot;, &quot;eu&quot;=&gt;&quot;Welcome to Turtle Beach!&quot;, &quot;fr&quot;=&gt;&quot;BIENVENUE SUR LE SITE DE TURTLE BEACH!&quot;, &quot;it&quot;=&gt;&quot;BENVENUTI IN TURTLE BEACH!&quot;, &quot;gb&quot;=&gt;&quot;Welcome to Turtle Beach!&quot;, &quot;nl&quot;=&gt;&quot;WELKOM BIJ TURTLE BEACH!&quot;, &quot;au&quot;=&gt;&quot;Welcome to Turtle Beach!&quot;, &quot;de&quot;=&gt;&quot;WILLKOMMEN BEI TURTLE BEACH!&quot;, &quot;es&quot;=&gt;&quot;BIENVENIDO A TURTLE BEACH!&quot;, &quot;mx&quot;=&gt;&quot;BIENVENIDO A TURTLE BEACH!&quot;, &quot;nz&quot;=&gt;&quot;Welcome to Turtle Beach!&quot;, &quot;ca&quot;=&gt;&quot;Welcome to Turtle Beach!&quot;, &quot;kr&quot;=&gt;&quot;Turtle Beach에 오신 것을 환영합니다!&quot;, &quot;jp&quot;=&gt;&quot;Turtle Beach へようこそ!&quot;}");
    return welcomeObject[ ipCountry ] || welcomeObject[ "us" ];
  },
  getAttentionString: function(ipCountry) {
    // Get text data for attention
    var attentionObject = theme.geoip.cleanJSONFromServer("{&quot;us&quot;=&gt;&quot;ATTENTION&quot;, &quot;eu&quot;=&gt;&quot;ATTENTION&quot;, &quot;fr&quot;=&gt;&quot;Attention&quot;, &quot;it&quot;=&gt;&quot;Attenzione&quot;, &quot;gb&quot;=&gt;&quot;ATTENTION&quot;, &quot;nl&quot;=&gt;&quot;Waarschuwing&quot;, &quot;au&quot;=&gt;&quot;ATTENTION&quot;, &quot;de&quot;=&gt;&quot;Achtung&quot;, &quot;es&quot;=&gt;&quot;Atención&quot;, &quot;mx&quot;=&gt;&quot;Atención&quot;, &quot;nz&quot;=&gt;&quot;ATTENTION&quot;, &quot;ca&quot;=&gt;&quot;ATTENTION&quot;, &quot;kr&quot;=&gt;&quot;주의&quot;, &quot;jp&quot;=&gt;&quot;注意&quot;}");
    return attentionObject[ ipCountry ] || attentionObject[ "us" ];
  },
  getNoticedString: function(ipCountry) {
    // Get text data for a welcome
    var noticedObject = theme.geoip.cleanJSONFromServer("{&quot;us&quot;=&gt;&quot;We noticed you are located in the United States&quot;, &quot;eu&quot;=&gt;&quot;We noticed you are located in the European Union&quot;, &quot;fr&quot;=&gt;&quot;Votre position actuelle : France&quot;, &quot;it&quot;=&gt;&quot;Abbiamo notato che ti trovi qui: Italia&quot;, &quot;gb&quot;=&gt;&quot;We noticed you are located in the United Kingdom&quot;, &quot;nl&quot;=&gt;&quot;We hebben gezien dat je je bevindt in: Nederland&quot;, &quot;au&quot;=&gt;&quot;We noticed you are located in Australia&quot;, &quot;de&quot;=&gt;&quot;Wie wir sehen, befindest du dich hier: Deutschland&quot;, &quot;es&quot;=&gt;&quot;Hemos observado que te encuentras en: España&quot;, &quot;mx&quot;=&gt;&quot;Hemos observado que te encuentras en: Latino America&quot;, &quot;nz&quot;=&gt;&quot;We noticed you are located in New Zealand&quot;, &quot;ca&quot;=&gt;&quot;We noticed you are located in Canada&quot;, &quot;kr&quot;=&gt;&quot;여러분의지역이우리나라인것으로확인됩니다&quot;, &quot;jp&quot;=&gt;&quot;お客様は日本にお住まいのようです。&quot;}");
    return noticedObject[ ipCountry ] || noticedObject[ "us" ];
  },
  getEnterString: function(ipCountry) {
    var enterObject = theme.geoip.cleanJSONFromServer("{&quot;us&quot;=&gt;&quot;Enter the US Site&quot;, &quot;eu&quot;=&gt;&quot;Enter the EU Site&quot;, &quot;fr&quot;=&gt;&quot;ENTRER SUR LE SITE FRANÇAIS&quot;, &quot;it&quot;=&gt;&quot;ENTRA NEL SITO ITALIANO&quot;, &quot;gb&quot;=&gt;&quot;Enter the UK Site&quot;, &quot;nl&quot;=&gt;&quot;GA NAAR DE NEDERLANDSE SITE&quot;, &quot;au&quot;=&gt;&quot;Enter the AU Site&quot;, &quot;de&quot;=&gt;&quot;DE-WEBSITE BESUCHEN&quot;, &quot;es&quot;=&gt;&quot;ENTRA EN LA PÁGINA DE ESPAÑA&quot;, &quot;mx&quot;=&gt;&quot;ENTRA EN LA PÁGINA DE Latino America&quot;, &quot;nz&quot;=&gt;&quot;Enter the NZ Site&quot;, &quot;ca&quot;=&gt;&quot;Enter the Canadian Site&quot;, &quot;kr&quot;=&gt;&quot;우리나라장소를입력하세요&quot;, &quot;jp&quot;=&gt;&quot;日本サイトにアクセス&quot;}");
    return enterObject[ ipCountry ] || enterObject[ "us" ];
  },
  getContinueString: function(ipCountry) {
    // Get text data for a welcome
    var continueObject = theme.geoip.cleanJSONFromServer("{&quot;us&quot;=&gt;&quot;Continue with US Site&quot;, &quot;eu&quot;=&gt;&quot;Continue with EU Site&quot;, &quot;fr&quot;=&gt;&quot;Continuer avec le site français&quot;, &quot;it&quot;=&gt;&quot;Continua sul sito italiano&quot;, &quot;gb&quot;=&gt;&quot;Continue with UK Site&quot;, &quot;nl&quot;=&gt;&quot;Doorgaan naar Nederlandse site&quot;, &quot;au&quot;=&gt;&quot;Continue with Australian Site&quot;, &quot;de&quot;=&gt;&quot;Auf der deutschen Seite fortfahren&quot;, &quot;es&quot;=&gt;&quot;Continuar en la página de España&quot;, &quot;mx&quot;=&gt;&quot;Continuar con el sitio de América Latina&quot;, &quot;nz&quot;=&gt;&quot;Continue with New Zealand Site&quot;, &quot;ca&quot;=&gt;&quot;Continue with the Canadian Site&quot;, &quot;kr&quot;=&gt;&quot;한국 사이트로 계속하기&quot;, &quot;jp&quot;=&gt;&quot;日本語のウェブサイトで続ける&quot;}");
    return continueObject[ ipCountry ] || continueObject[ "us" ];
  },
  getCountryButtonsString: function(ipCountry) {
    // Get text data for a welcome
    var countryButtonsObject = theme.geoip.cleanJSONFromServer("{&quot;us&quot;=&gt;{&quot;us&quot;=&gt;&quot;United States&quot;, &quot;eu&quot;=&gt;&quot;European Union&quot;, &quot;fr&quot;=&gt;&quot;France&quot;, &quot;it&quot;=&gt;&quot;Italy&quot;, &quot;gb&quot;=&gt;&quot;United Kingdom&quot;, &quot;nl&quot;=&gt;&quot;Netherlands&quot;, &quot;au&quot;=&gt;&quot;Australia&quot;, &quot;de&quot;=&gt;&quot;Germany&quot;, &quot;es&quot;=&gt;&quot;Spain&quot;, &quot;mx&quot;=&gt;&quot;Latin America&quot;, &quot;nz&quot;=&gt;&quot;New Zealand&quot;, &quot;ca&quot;=&gt;&quot;Canada&quot;, &quot;latam&quot;=&gt;&quot;Latin America&quot;, &quot;cn&quot;=&gt;&quot;China&quot;, &quot;hk&quot;=&gt;&quot;Hong Kong&quot;, &quot;jp&quot;=&gt;&quot;Japan&quot;, &quot;kr&quot;=&gt;&quot;Korea&quot;}, &quot;eu&quot;=&gt;{&quot;us&quot;=&gt;&quot;United States&quot;, &quot;ca&quot;=&gt;&quot;Canada&quot;, &quot;eu&quot;=&gt;&quot;European Union&quot;, &quot;fr&quot;=&gt;&quot;France&quot;, &quot;it&quot;=&gt;&quot;Italy&quot;, &quot;gb&quot;=&gt;&quot;United Kingdom&quot;, &quot;nl&quot;=&gt;&quot;Netherlands&quot;, &quot;au&quot;=&gt;&quot;Australia&quot;, &quot;de&quot;=&gt;&quot;Germany&quot;, &quot;es&quot;=&gt;&quot;Spain&quot;, &quot;mx&quot;=&gt;&quot;Latin America&quot;, &quot;nz&quot;=&gt;&quot;New Zealand&quot;}, &quot;fr&quot;=&gt;{&quot;us&quot;=&gt;&quot;États-Unis&quot;, &quot;ca&quot;=&gt;&quot;Canada&quot;, &quot;eu&quot;=&gt;&quot;Union européenne&quot;, &quot;fr&quot;=&gt;&quot;France&quot;, &quot;it&quot;=&gt;&quot;Italie&quot;, &quot;gb&quot;=&gt;&quot;Royaume-Uni&quot;, &quot;nl&quot;=&gt;&quot;Pays-Bas&quot;, &quot;au&quot;=&gt;&quot;Australie&quot;, &quot;de&quot;=&gt;&quot;Allemagne&quot;, &quot;es&quot;=&gt;&quot;Espagne&quot;, &quot;mx&quot;=&gt;&quot;Latin America&quot;, &quot;nz&quot;=&gt;&quot;Nouvelle-Zélande&quot;}, &quot;it&quot;=&gt;{&quot;us&quot;=&gt;&quot;Stati Uniti&quot;, &quot;ca&quot;=&gt;&quot;Canada&quot;, &quot;eu&quot;=&gt;&quot;Unione europea&quot;, &quot;fr&quot;=&gt;&quot;Francia&quot;, &quot;it&quot;=&gt;&quot;Italia&quot;, &quot;gb&quot;=&gt;&quot;Regno Unito&quot;, &quot;nl&quot;=&gt;&quot;Olanda&quot;, &quot;au&quot;=&gt;&quot;Australia&quot;, &quot;de&quot;=&gt;&quot;Germania&quot;, &quot;es&quot;=&gt;&quot;Spagna&quot;, &quot;mx&quot;=&gt;&quot;Latin America&quot;, &quot;nz&quot;=&gt;&quot;Nuova Zelanda&quot;}, &quot;gb&quot;=&gt;{&quot;us&quot;=&gt;&quot;United States&quot;, &quot;ca&quot;=&gt;&quot;Canada&quot;, &quot;eu&quot;=&gt;&quot;European Union&quot;, &quot;fr&quot;=&gt;&quot;France&quot;, &quot;it&quot;=&gt;&quot;Italy&quot;, &quot;gb&quot;=&gt;&quot;United Kingdom&quot;, &quot;nl&quot;=&gt;&quot;Netherlands&quot;, &quot;au&quot;=&gt;&quot;Australia&quot;, &quot;de&quot;=&gt;&quot;Germany&quot;, &quot;es&quot;=&gt;&quot;Spain&quot;, &quot;mx&quot;=&gt;&quot;Latin America&quot;, &quot;nz&quot;=&gt;&quot;New Zealand&quot;}, &quot;nl&quot;=&gt;{&quot;us&quot;=&gt;&quot;Verenigde Staten&quot;, &quot;ca&quot;=&gt;&quot;Canada&quot;, &quot;eu&quot;=&gt;&quot;Europese Unie&quot;, &quot;fr&quot;=&gt;&quot;Frankrijk&quot;, &quot;it&quot;=&gt;&quot;Italië&quot;, &quot;gb&quot;=&gt;&quot;Verenigd Koninkrijk&quot;, &quot;nl&quot;=&gt;&quot;Nederland&quot;, &quot;au&quot;=&gt;&quot;Australië&quot;, &quot;de&quot;=&gt;&quot;Duitsland&quot;, &quot;es&quot;=&gt;&quot;Spanje&quot;, &quot;mx&quot;=&gt;&quot;Latin America&quot;, &quot;nz&quot;=&gt;&quot;Nieuw-Zeeland&quot;}, &quot;au&quot;=&gt;{&quot;us&quot;=&gt;&quot;United States&quot;, &quot;ca&quot;=&gt;&quot;Canada&quot;, &quot;eu&quot;=&gt;&quot;European Union&quot;, &quot;fr&quot;=&gt;&quot;France&quot;, &quot;it&quot;=&gt;&quot;Italy&quot;, &quot;gb&quot;=&gt;&quot;United Kingdom&quot;, &quot;nl&quot;=&gt;&quot;Netherlands&quot;, &quot;au&quot;=&gt;&quot;Australia&quot;, &quot;de&quot;=&gt;&quot;Germany&quot;, &quot;es&quot;=&gt;&quot;Spain&quot;, &quot;mx&quot;=&gt;&quot;Latin America&quot;, &quot;nz&quot;=&gt;&quot;New Zealand&quot;}, &quot;de&quot;=&gt;{&quot;us&quot;=&gt;&quot;USA&quot;, &quot;ca&quot;=&gt;&quot;Canada&quot;, &quot;eu&quot;=&gt;&quot;Europäische Union&quot;, &quot;fr&quot;=&gt;&quot;Frankreich&quot;, &quot;it&quot;=&gt;&quot;Italien&quot;, &quot;gb&quot;=&gt;&quot;Großbritannien&quot;, &quot;nl&quot;=&gt;&quot;Niederlande&quot;, &quot;au&quot;=&gt;&quot;Australien&quot;, &quot;de&quot;=&gt;&quot;Deutschland&quot;, &quot;es&quot;=&gt;&quot;Spanien&quot;, &quot;mx&quot;=&gt;&quot;Latin America&quot;, &quot;nz&quot;=&gt;&quot;Neuseeland&quot;}, &quot;es&quot;=&gt;{&quot;us&quot;=&gt;&quot;Estados Unidos&quot;, &quot;ca&quot;=&gt;&quot;Canada&quot;, &quot;eu&quot;=&gt;&quot;Unión Europea&quot;, &quot;fr&quot;=&gt;&quot;Francia&quot;, &quot;it&quot;=&gt;&quot;Italia&quot;, &quot;gb&quot;=&gt;&quot;Reino Unido&quot;, &quot;nl&quot;=&gt;&quot;Países Bajos&quot;, &quot;au&quot;=&gt;&quot;Australia&quot;, &quot;de&quot;=&gt;&quot;Alemania&quot;, &quot;es&quot;=&gt;&quot;España&quot;, &quot;mx&quot;=&gt;&quot;Latin America&quot;, &quot;nz&quot;=&gt;&quot;Nueva Zelanda&quot;}, &quot;nz&quot;=&gt;{&quot;us&quot;=&gt;&quot;United States&quot;, &quot;ca&quot;=&gt;&quot;Canada&quot;, &quot;eu&quot;=&gt;&quot;European Union&quot;, &quot;fr&quot;=&gt;&quot;France&quot;, &quot;it&quot;=&gt;&quot;Italy&quot;, &quot;gb&quot;=&gt;&quot;United Kingdom&quot;, &quot;nl&quot;=&gt;&quot;Netherlands&quot;, &quot;au&quot;=&gt;&quot;Australia&quot;, &quot;de&quot;=&gt;&quot;Germany&quot;, &quot;es&quot;=&gt;&quot;Spain&quot;, &quot;mx&quot;=&gt;&quot;Latin America&quot;, &quot;nz&quot;=&gt;&quot;New Zealand&quot;}}");
    return countryButtonsObject[ ipCountry ] || countryButtonsObject[ "us" ];
  },
  getCurrentSite: function() {
    var url = window.location.hostname;

    //check for localhost, dev, or qa. Also US site (since it's www, not us.turtlebeach.com)
    if ( /localhost|www.turtlebeach|os-atom|trtl-qa/gi.test( url ) ) return "us";

    //If we are on QA or Stage this will return a result
    var matchSite = /tr([A-Za-z]{2})+/g.exec(url);
    if (matchSite !== null) {
      if (matchSite[1] === "uk") return "gb";
      return matchSite[1];
    }

    //Return the currentSite based on the prod url
    var index = url.indexOf('.');
    var currentSite = url.slice(0,index);
    //UK subdomain is uk., but the correct designation is GB, so return that instead
    if (currentSite === "uk") return "gb";

    // Adjusting currenSite value for edge case countries
    if (currentSite === 'latam') {
      currentSite = 'mx';
    }
    if (currentSite === 'at') {
      currentSite = 'de';
    }

    return currentSite;
  },
  closeModal: function() {
    var modalElement = document.querySelector('#international-modal');
    modalElement.setAttribute('data-show-modal', 'false');
    document.body.style.overflow = "auto";
  },
  getCookie: function() {
    var value = "; " + document.cookie;
    var parts = value.split("; geo-location=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  },
  setCookie: function(value) {
    

    var expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 7);
    var domain = "." + location.hostname.split('.').reverse()[1] + "." + location.hostname.split('.').reverse()[0];
    //for local testing
    if (location.hostname === "localhost") domain = "localhost";
    document.cookie = "geo-location=" + value + "; expires=" + expirationDate.toDateString() +  "; domain=" + domain + "; path=/";
  },
  routeSite: function(currentSite, currentLocale, countryByIp) {
    // used by non-transactional stores
    window.theme.usersCountry = countryByIp;

    

    //Check if they are already on the correct site
    if ( currentLocale.toLowerCase() === currentSite.toLowerCase() || countryByIp.toLowerCase() === currentSite.toLowerCase() ) {
      console.log('same site');
      return;
    }

    if (latamCountries.includes(countryByIp)) {
      console.log('latam site');
      latam = true;
      if (currentSite === 'mx') {
        theme.geoip.setCookie(countryByIp);
        return;
      }
    }

    if ( euCountries.includes(countryByIp) ) {
      if (currentSite === 'eu') {
        countryByIp = "eu";
        theme.geoip.setCookie(countryByIp);
        return;
      }
    }

    if ( euCountries.includes(countryByIp) && !shopLocations.includes(countryByIp) ) {
      countryByIp = "eu";
    }

    if ( !shopLocations.includes(countryByIp) ) {
      return;
    }

    //display the international popup, and show the correct country and site name
    var modalElement = document.querySelector('#international-modal');
    modalElement.setAttribute('data-show-modal', 'true');
    document.body.style.overflow = "hidden";

    //Set the text for the various strings in the modal
    var welcomeElement = document.querySelector('#international-welcome');
    welcomeElement.innerText = theme.geoip.getWelcomeString(countryByIp);

    var attentionElement = document.querySelector('#attention');
    attentionElement.innerText = theme.geoip.getAttentionString(countryByIp);

    var noticedMessageElement = document.querySelector('#noticed-message');
    noticedMessageElement.innerText = theme.geoip.getNoticedString(countryByIp);

    var enterSiteElement = document.querySelector('#enter-site');
    enterSiteElement.innerText = theme.geoip.getEnterString(countryByIp);

    var enterLink = document.querySelector('#international-modal .btn--primary');

    enterLink.setAttribute("href", siteLinks[countryByIp]);

    var continueElement = document.querySelector('#continue-link');
    continueElement.innerText = theme.geoip.getContinueString(currentSite);

    continueElement.onclick = function(e) {
      e.preventDefault();
      theme.geoip.setCookie(currentSite);
      modalElement.setAttribute('data-show-modal', 'false');
      document.body.style.overflow = "auto";
    };

    //Set the text for each country button
    var countryButtonTextArry = theme.geoip.getCountryButtonsString(countryByIp);
    Object.keys(countryButtonTextArry).forEach(function(i){
      var countryButton = document.querySelector('.international-site-list #' + i + ' span');
      countryButton.innerText = countryButtonTextArry[i];
    });
  }
}

theme.geoip.init();